import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
} from '../../../../../components/ui/Dialog';
import { Button } from '../../../../../components/ui/Button';
import UnitsForm from '../forms/UnitsForm';
import { useDispatch, useSelector } from 'react-redux';
import { getCultures } from '@/store/actions/culture';

const UnitsModal = ({
  visible,
  onClose,
  submitForm,
  formProps,
  error,
  title,
  isActiveForm,
  isEditCultureMutations = false,
}) => {
  const [submit, setSubmit] = useState(false);
  const { cultures } = useSelector((state) => state.culture);
  const dispatch = useDispatch();

  useEffect(() => {
    let mounted = true;

    if (mounted && cultures && !(cultures.length > 0)) {
      dispatch(getCultures());
    }
    return () => {
      mounted = false;
    };
  }, [cultures]);

  const formSubmit = (values) => {
    submitForm(values);
    setSubmit(false);
  };

  return (
    <Dialog open={visible} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <UnitsForm
            submitOutside={submit}
            submit={formSubmit}
            formProps={formProps}
            cultures={cultures}
            resetConfirm={() => {}}
            isActiveForm={isActiveForm}
            isEditCultureMutations={isEditCultureMutations}
            reset={null}
            error={error}
          />
        </DialogBody>
        <DialogFooter>
          <Button
            key={1}
            variant="outline"
            onClick={() => onClose()}
            data-testid="units-modal-close-btn"
          >
            Zavřít
          </Button>
          <Button key={2} onClick={() => setSubmit(true)} data-testid="units-modal-save-btn">
            Uložit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UnitsModal;
